import { create } from 'zustand';
import type { ChatWidgetPosition } from './use-chat-widget-position';

/** How the chat is on screen. Mirrors what ChatWidget derives; it publishes, nobody else writes. */
export type ChatWidgetPresentation = 'button' | 'floating' | 'docked' | 'fullscreen';
type ChatWidgetPresentationState = {
  presentation: ChatWidgetPresentation;
  position: ChatWidgetPosition;
  publish: (next: {
    presentation: ChatWidgetPresentation;
    position: ChatWidgetPosition;
  }) => void;
};

// ChatWidget derives its presentation from session state only it holds (a route-locked fullscreen,
// the investigation dock, whether a layout slot exists), so anything that needs to stay out of the
// chat's way reads it from here rather than recomputing it and drifting.
const useStore = create<ChatWidgetPresentationState>(set => ({
  presentation: 'button',
  position: 'bottom-right',
  publish: next => set(next)
}));
const useChatWidgetPresentation = () => {
  return useStore();
};
export default useChatWidgetPresentation;